//all
// fair_use: 'Fair Use',
// direct_listening: 'Direct Listening',
// callback: 'Callback',
// voLTEVoWifi: 'VoLTE/VoWifi',
// sms_cut_off: 'SMS Cut Off',
// data_cut_off: 'Data Cut Off',
// conferencing: 'Conferencing',
// voice_cut_off: 'Voice Cut Off',
// fiveG: '5G',
// data: 'Data',
// voiceMail: 'Voice Mail',
// visualVoiceMail: 'Visual Voice Mail',
// callWaiting: 'Call Waiting',
// blockVoicePremium: 'Block Voice Premium',
// blockSMSPremium: 'Block SMS Premium',

export const optionMapping: Record<string, string> = {
  voLTEVoWifi: 'VoLTE/VoWifi',
  conferencing: 'Conférence',
  fiveG: '5G',
  blockVoicePremium: 'Bloquer les appels surtaxés',
  blockSMSPremium: 'Bloquer les SMS surtaxés',
};

export const optionDescriptionMapping: Record<string, string> = {
  voLTEVoWifi:
    'Cette option permet les appels sur 4G et sur le wifi (à condition d\'avoir une box et un téléphone compatible). Cette option est gratuite.',
  conferencing:
    'Cette option permet d\'ajouter jusqu\'à trois utilisateurs pour un même appel. Cette option est gratuite.',
  fiveG: 'Option gratuite.',
  blockVoicePremium:
    'Cette option permet de bloquer les appels vers les numéros commençant par 08, numéros payants dans la majorité des cas. Option gratuite.',
  blockSMSPremium:
    'Cette option permet de bloquer les SMS payants. Option gratuite.',
};
